// user follows the default outbound calling logic
export const OUTBOUND_CALLING_MODE_DEFAULT = 1
// user will always be asked to select an outbound campaign
export const OUTBOUND_CALLING_MODE_ALWAYS_ASK = 2
